import { CompletionReward, FeeVoucherReward } from '@flipster/apis/v1/rewardHub/types';
import { FormattedMessage } from '@flipster/i18n';
import { Modal } from '@flipster/react/design-system/modal';
import { Datetime } from '@flipster/react/design-utils/datetime';
import Formatted from '@flipster/react/design-utils/formatted';
import { css } from '@flipster/styled-system/css';
import { UsdtCurrency } from '@flipster/utils/constants/currency';

import Celebration from '../assets/images/celebration.svg';
import { getRewardAmount, getRewardCurrency, getRewardType, isCashReward } from './utils';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onExit: () => void;
  completionReward: CompletionReward;
  distributionDate?: string;
  feeVoucherRewardRecord?: Record<number, FeeVoucherReward>;
}

const ClaimModal = ({ isOpen, onClose, onExit, completionReward, distributionDate, feeVoucherRewardRecord }: Props) => {
  const rewardType = getRewardType(completionReward);
  const rewardAmount = getRewardAmount(completionReward, feeVoucherRewardRecord);
  const currency = isCashReward(completionReward) ? getRewardCurrency(completionReward) : UsdtCurrency;

  if (!rewardType) return null;

  return (
    <Modal.Root isOpen={isOpen} size='small' mode='bottomSheet' onClose={onClose} onExit={onExit}>
      <Modal.Content css={{ textAlign: 'center', p: 16 }}>
        <Celebration width={70} height={70} />
        <div className={css({ textStyle: 'Title/M', color: 'content.default.level-5', mt: 16 })}>
          {rewardTypeDescription[rewardType] && (
            <p className={css({ textStyle: 'Text/M/Strong', color: 'content.default.level-5', mb: 4 })}>
              {rewardTypeDescription[rewardType]}
            </p>
          )}
          <FormattedMessage
            id='Reward_hub.r260128.Popup_claimed'
            values={{
              amountSymbol: <Formatted.Number value={rewardAmount} precision={0} toFixed suffix={currency} />,
            }}
          />
        </div>
        {distributionDate && (
          <div className={css({ textStyle: 'Text/M/Regular', color: 'content.default.level-3', mt: 4 })}>
            <FormattedMessage
              id='Reward_hub.r251216.Distributed_by_date'
              values={{ date: <Datetime value={distributionDate} format='yyyy.MM.dd, HH:mm' isUTC withUTCText /> }}
            />
          </div>
        )}
      </Modal.Content>
      <Modal.Footer>
        <Modal.Button
          size='large'
          hierarchy='primary'
          color='accent'
          label={<FormattedMessage id='Common.r250918.Got_it' />}
          onClick={onClose}
        />
      </Modal.Footer>
    </Modal.Root>
  );
};

export default ClaimModal;

const rewardTypeDescription = {
  cash: null,
  marginBonus: <FormattedMessage id='Reward_hub.r260128.Popup_claimed_bonus' />,
  feeVoucher: <FormattedMessage id='Reward_hub.r260128.Popup_claimed_feevoucher' />,
};
